import React from 'react';
import { useTranslation } from '../../../i18n';
import '../../../styles/bonus-countdown.css';

interface BonusCountdownProps {
  /** Currently visible digit: 3, 2, or 1. */
  digit: 3 | 2 | 1;
}

/**
 * Reusable 3-2-1 countdown display for bonus intro (host).
 * Big font, zoom-in + blink animation, fixed at bottom. Parent switches digit every second.
 */
export const BonusCountdown: React.FC<BonusCountdownProps> = ({ digit }) => {
  const { t } = useTranslation();

  return (
    <div className="bonus-countdown-wrap" aria-live="polite" aria-atomic="true">
      <div className="bonus-countdown-inner">
        <span className="bonus-countdown-label">{t('bonus.countdown.getReady')}</span>
        <span className="bonus-countdown-digit" key={digit}>
          {digit}
        </span>
      </div>
    </div>
  );
};
